import { render, staticRenderFns } from "./LazyLoadingImage.vue?vue&type=template&id=5036046c&"
import script from "./LazyLoadingImage.vue?vue&type=script&lang=ts&"
export * from "./LazyLoadingImage.vue?vue&type=script&lang=ts&"
import style0 from "./LazyLoadingImage.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports